import React, { useState, useEffect, useRef } from "react";

import { RiMoneyDollarBoxFill } from "react-icons/ri";
import { MdChromeReaderMode } from "react-icons/md";
import { IoIosPricetags } from "react-icons/io";
import { GoAlertFill } from "react-icons/go";
import { FaChartLine } from "react-icons/fa";
import { TbResize } from "react-icons/tb";
import { BiSolidOffer } from "react-icons/bi";
import { TbReportMoney } from "react-icons/tb";

import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { fetchSettings, fetchUserDetails, updateSettings } from "../services/settings";
import SasPanels from "../components/Settings/SasPanel";
import QuickInfo from "../components/Settings/QuickInfo";
import DefaultValues from "../components/Settings/DefaultValues";
import AdditionalCosts from "../components/Settings/AdditionalCost";
import BuyingCriteria from "../components/Settings/BuyingCriteria";
import UserDetails from "../components/Settings/UserDetails";
import TooltipSimple from "../components/TooltipSimple";
import FulfillmentandStorage from "../components/Settings/FullfilmentStore";
import { fieldToSectionMap } from "../utils/constants";

const Settings = () => {
  const [settingsData, setSettingsData] = useState([]);
  const [userData, setUserData] = useState([]);

  const navigate = useNavigate();

  const userDetailsRef = useRef(null);
  const vatRef = useRef(null);
  const buyingCriteriaRef = useRef(null);
  const additionalCostsRef = useRef(null);
  const defaultValuesRef = useRef(null);
  const fulfillmentandStorageRef = useRef(null);
  const quickInfoRef = useRef(null);
  const tagsRef = useRef(null);
  const sasPanelsRef = useRef(null);

  const handleIconClick = (ref) => {
    if (ref && ref.current) {
      const element = ref.current;
      const offsetTop = element.getBoundingClientRect().top;
      const scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      const targetScrollPosition = scrollPosition + offsetTop - 100;
      window.scrollTo({ top: targetScrollPosition, behavior: "smooth" });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchSettings();
      setSettingsData(data);

      const accessToken = localStorage.getItem("accessToken");
      if (!accessToken) {
        console.log("No access token found");
        navigate("/");
      } else {
        const user = await fetchUserDetails();
        if (!user) {
          console.log("No user found");
          navigate("/");
        } else{
          setUserData(user.user);
        }
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!settingsData || settingsData.length === 0) return;
    const updateData = async () => {
      const data = await updateSettings(settingsData);
      console.log("Updated data:", data);
    };
    updateData();
  }, [settingsData]);

 const handleUpdateSettingsSection = (fields, toastMessage = null) => {
    const updatesBySection = {};
    let marketplaceUpdate = null;
    
    // Separate marketplace field from other fields
    for (const [key, value] of Object.entries(fields)) {
        if (key === 'marketplace') {
            marketplaceUpdate = value;
            continue;
        }

        const section = fieldToSectionMap[key];
        if (!section) {
            continue;
        }

        if (!updatesBySection[section]) updatesBySection[section] = {};
        updatesBySection[section][key] = value;
    }

    const updatedSettingsData = { ...settingsData };
    let hasChanges = false;

    // Check for marketplace changes
    if (marketplaceUpdate !== null && marketplaceUpdate !== undefined) {
        if (String(settingsData.marketplace) !== String(marketplaceUpdate)) {
            updatedSettingsData.marketplace = marketplaceUpdate;
            hasChanges = true;
        }
    }

    // Check for section changes
    for (const [section, values] of Object.entries(updatesBySection)) {
        updatedSettingsData[section] = {
            ...updatedSettingsData[section],
            ...values,
        };

        for (const [key, value] of Object.entries(values)) {
            const oldValue = settingsData?.[section]?.[key];
            if (String(oldValue) !== String(value)) {
                hasChanges = true;
            }
        }
    }

    if (!hasChanges) {
        console.log("No changes detected — skipping update.");
        return;
    }

    const updateData = async () => {
        try {
            const res = await updateSettings(updatedSettingsData);
            setSettingsData(updatedSettingsData);
            if (toastMessage) toast.success(toastMessage);
        } catch (error) {
            console.error("Failed to update settings:", error);
        }
    };

    updateData();
};  
  
  const handleUpdateUserDetails = (data) => {
    handleUpdateSettingsSection(data);
  };
  
  const handleUpdateVAT = (data) => {
    handleUpdateSettingsSection(data);
  };
  
  const handleUpdateBuyingCriteria = (data) => {
    handleUpdateSettingsSection(data, "Buying criteria updated successfully");
  };
  
  const handleUpdateQuickInfo = (data) => {
    handleUpdateSettingsSection(data, "Quick Info Updated");
  };
  
  const handleUpdateMiscellaneous = (data) => {
    handleUpdateSettingsSection(data, "Miscellaneous Settings Updated!!");
  };
  
  const handleUpdateSas = (data) => {
    handleUpdateSettingsSection(data, "Panel Settings Updated!!");
  };
  
  const handleUpdateMarketplace = (data) => {
    handleUpdateSettingsSection(data, "Marketplace Updated");
  };
  
  const handleUpdateAdditionalCosts = (data) => {
    handleUpdateSettingsSection(data, "Additional Costs Updated");
  };
  
  const handleUpdateDefaultValues = (data) => {
    handleUpdateSettingsSection(data, "Default Values Updated");
  };
  
  return (
    <div className="App bg-primary-bg p-2">
      <div
        className="flex flex-col w-full border-primary bg-primary-bg mt-3 p-3"
        style={{
          position: "sticky",
          top: "2px",
          border: "0.5px solid #76F99B",
          borderRadius: "24px",
          zIndex: "1",
        }}
      >
        <div className="flex">
          <div
            class="w-8 h-8 group relative rounded-lg ml-2 bg-primary flex justify-center items-center text-primary-dark"
            onClick={() => handleIconClick(userDetailsRef)}
            style={
              {
                // background: "#052308",
              }
            }
          >
            <MdChromeReaderMode />
            <TooltipSimple width="auto" text="User Details" />
          </div>
          {/* <div
            class="w-8 h-8 group relative rounded-lg ml-2 bg-primary flex justify-center items-center text-primary-dark"
            onClick={() => handleIconClick(vatRef)}
            style={
              {
                // background: "#052308",
              }
            }
          >
            <IoIosPricetags />
            <TooltipSimple width="auto" text="VAT" />
          </div> */}
          <div
            class="w-8 h-8 group relative rounded-lg ml-2 bg-primary flex justify-center items-center text-primary-dark"
            onClick={() => handleIconClick(buyingCriteriaRef)}
            style={
              {
                // background: "#052308",
              }
            }
          >
            <GoAlertFill />
            <TooltipSimple width="auto" text="BSR" />
          </div>
          <div
            class="w-8 h-8 group relative rounded-lg ml-2 bg-primary flex justify-center items-center text-primary-dark"
            onClick={() => handleIconClick(additionalCostsRef)}
            style={
              {
                // background: "#052308",
              }
            }
          >
            <RiMoneyDollarBoxFill className="" />
            <TooltipSimple width="auto" text="Profit & Cost" />
          </div>
          <div
            class="w-8 h-8 group relative rounded-lg ml-2 bg-primary flex justify-center items-center text-primary-dark"
            onClick={() => handleIconClick(defaultValuesRef)}
            style={
              {
                // background: "#052308",
              }
            }
          >
            <FaChartLine />
            <TooltipSimple width="auto" text="Date Time Frames" />
          </div>
          <div
            class="w-8 h-8 group relative rounded-lg ml-2 bg-primary flex justify-center items-center text-primary-dark"
            onClick={() => handleIconClick(fulfillmentandStorageRef)}
            style={
              {
                // background: "#052308",
              }
            }
          >
            <BiSolidOffer />
            <TooltipSimple width="auto" text="Fulfillment & Storage" />
          </div>
          <div
            class="w-8 h-8 group relative rounded-lg ml-2 bg-primary flex justify-center items-center text-primary-dark"
            onClick={() => handleIconClick(quickInfoRef)}
            style={
              {
                // background: "#052308",
              }
            }
          >
            <TbResize />
            <TooltipSimple width="auto" text="Display Options" />
          </div>
          {/* <div
            class="w-8 h-8 group relative rounded-lg ml-2 bg-primary flex justify-center items-center text-primary-dark"
            onClick={() => handleIconClick(tagsRef)}
            style={
              {
                // background: "#052308",
              }
            }
          >
            <BiSolidOffer />
            <TooltipSimple width="auto" text="Tags" />
          </div> */}
          <div
            class="w-8 h-8 group relative rounded-lg ml-2 bg-primary flex justify-center items-center text-primary-dark"
            onClick={() => handleIconClick(sasPanelsRef)}
            style={
              {
                // background: "#052308",
              }
            }
          >
            <TbReportMoney />
            <TooltipSimple width="auto" text="ScanProfit Panels" />
          </div>
        </div>
      </div>

      <div className="text-white">
        <div ref={userDetailsRef}>
          <UserDetails
            userId={settingsData?.userId}
            data={userData}
            handleUpdate={handleUpdateUserDetails}
            settings={settingsData}
            handleUpdateMarketplace={handleUpdateMarketplace}
          />
        </div>
        <div ref={buyingCriteriaRef}>
          <BuyingCriteria
            data={settingsData?.buyingCriteria}
            handleUpdate={handleUpdateBuyingCriteria}
            settings={settingsData}
          />
        </div>
        <div ref={additionalCostsRef}>
          <AdditionalCosts
            data={{
              ...settingsData?.additionalCosts,
              minProfit: settingsData?.buyingCriteria?.minProfit,
              minroi: settingsData?.buyingCriteria?.minroi,
              fba_inbound_placement_service: settingsData?.defaultValues?.fba_inbound_placement_service,
              marketplace: settingsData?.marketplace
            }}            
            handleUpdate={handleUpdateAdditionalCosts}
            settings={settingsData}
          />
        </div>
        <div ref={defaultValuesRef}>
          <DefaultValues
            data={settingsData?.defaultValues}
            handleUpdate={handleUpdateDefaultValues}
            settings={settingsData}
          />
        </div>
        <div ref={fulfillmentandStorageRef}>
          <FulfillmentandStorage
            data={settingsData?.defaultValues}
            handleUpdate={handleUpdateDefaultValues}
            settings={settingsData}
          />
        </div>
  
        <div ref={quickInfoRef}>
          <QuickInfo
            data={settingsData?.quickInfo}
            handleUpdate={handleUpdateQuickInfo}
          />
        </div>
   
        <div ref={sasPanelsRef}>
          <SasPanels
            data={settingsData?.panels}
            handleUpdate={handleUpdateSas}
          />
        </div>
      </div>
    </div>
  );
};

export default Settings;
